const startedAt = typeof performance !== 'undefined' ? performance.now() : Date.now()
const marks = new Map([['app_startup', startedAt]])
const summary = new Map()

function now() {
  return typeof performance !== 'undefined' ? performance.now() : Date.now()
}

function enabled() {
  return typeof process === 'undefined' || process.env?.NODE_ENV !== 'production'
}

function safeDetail(detail = {}) {
  const allowed = ['clubCode', 'category', 'status', 'reason', 'cache', 'durationMs', 'attempt']
  return Object.fromEntries(allowed.filter((key) => detail[key] != null).map((key) => [key, detail[key]]))
}

/** Development-only, privacy-safe Members mobile bootstrap timing. */
export function markBootstrap(event, detail = {}) {
  const at = now()
  marks.set(event, at)
  const safe = safeDetail(detail)
  if (safe.durationMs != null) summary.set(event, Number(safe.durationMs))
  if (enabled()) console.info('[members-bootstrap]', { event, elapsedMs: Math.round(at - startedAt), ...safe })
  return at
}

export function startBootstrapSpan(event, detail = {}) {
  const start = now()
  markBootstrap(`${event}_start`, detail)
  let ended = false
  return (endDetail = {}) => {
    if (ended) return 0
    ended = true
    const durationMs = Math.round(now() - start)
    markBootstrap(`${event}_end`, { ...detail, ...endDetail, durationMs })
    return durationMs
  }
}

export function emitBootstrapSummary(extra = {}) {
  const payload = {
    shellMs: marks.has('dashboard_first_shell_render') ? Math.round(marks.get('dashboard_first_shell_render') - startedAt) : null,
    nameMs: marks.has('first_member_name_render') ? Math.round(marks.get('first_member_name_render') - startedAt) : null,
    freshProfileMs: marks.has('first_fresh_member_profile_render') ? Math.round(marks.get('first_fresh_member_profile_render') - startedAt) : null,
    profileRequestMs: summary.get('member_profile_request_end') ?? null,
    ...safeDetail(extra),
  }
  if (enabled()) console.info('[members-bootstrap-summary]', payload)
  return payload
}

export function resetBootstrapTelemetryForTests() {
  marks.clear()
  marks.set('app_startup', now())
  summary.clear()
}
